import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export interface ImageUploadProgressDialogProps {
  open: boolean;
  /** 默认：正在上传预览图 */
  title?: string;
  /** 默认：WebP 上传到存储的说明 */
  description?: string;
}

/** Spine Avatar 预览图上传到存储时的阻塞弹窗（create-avatar / 套装保存等流程） */
export function ImageUploadProgressDialog({
  open,
  title = "正在上传预览图",
  description = "正在将 WebP 动图上传到存储，请稍候…",
}: ImageUploadProgressDialogProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        className="max-w-sm"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col items-center gap-3 py-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p className="text-center text-sm text-muted-foreground">
            {description}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
